import React, { useState, useEffect } from "react";
import { FaFacebookSquare, FaLine, FaEnvelope } from "react-icons/fa";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import OurServicesSection from "./Home-page/OurServicesSection";
import logoImage from "../image/favicon.jpg";
import "../components/css/Home-page.css";
import about from "../image/favicon1.png";
import Main from "./Home-page/LandingPage";
import Certificate from "./Home-page/Certificate";
import Contact from "./Home-page/Contact";

function HomePage() {
  const { t } = useTranslation();
  // ใช้ localStorage เพื่อแสดง splash เฉพาะครั้งแรก
  const [isLoading, setIsLoading] = useState(() => {
    const hasAnimated = localStorage.getItem('logoAnimated');
    return !hasAnimated;
  });

  useEffect(() => {
    if (isLoading) {
      const timer = setTimeout(() => {
        setIsLoading(false);
        localStorage.setItem('logoAnimated', 'true');
        document.body.classList.add("loaded");
      }, 3500);
      return () => clearTimeout(timer);
    } else {
      document.body.classList.add("loaded");
    }
  }, [isLoading]);

  // ...existing code...

  return (
    <>
      {isLoading && (
        <motion.div
          className="splash-screen"
          initial={{ opacity: 1 }}
          animate={{ opacity: 0 }}
          transition={{ duration: 1.5, delay: 2 }}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background:
              "linear-gradient(135deg,rgb(255, 255, 255),rgb(255, 255, 255))",
            opacity: 0.7,
            zIndex: 9999,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            color: "white",
            fontFamily: "Prompt, sans-serif",
          }}
        >
          <motion.img
            src={logoImage}
            alt="Logo"
            initial={{ scale: 0.7, opacity: 0 }}
            animate={{ scale: 1.1, opacity: 1 }}
            transition={{ duration: 1 }}
            style={{
              width: "130px",
              height: "130px",
              borderRadius: "50%",
              marginBottom: "20px",
              boxShadow: "0 0 30px rgba(255,255,255,0.3)",
            }}
          />
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2, delay: 0.5 }}
            style={{
              fontSize: "2.5rem",
              fontWeight: "bold",
              color: "black",
              letterSpacing: "2px",
            }}
          >
            ORNANONG ACCOUNTING
          </motion.h1>
        </motion.div>
      )}
      {/* bg-animated อยู่ด้านบนสุด */}
      <div className="bg-animated" id="home"></div>
      {/* ส่วน hero พร้อมพื้นหลัง */}
      <div className="hero-wrapper ">
        <div
          className="container mt-5 d-flex justify-content-center align-items-center"
          style={{
            width: "100%",
            minHeight: "80vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <motion.div
            className="row align-items-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.2 }}
          >
            <div className="col-lg-8 mx-auto text-center">
              <main style={{  }}>
                <Main />
              </main>
              <motion.div
                className="d-flex justify-content-center align-items-center flex-column flex-sm-row gap-3"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, delay: 0.6 }}
                style={{
                  width: "100%",
                  padding: "0 15px"
                }}
              >
                <a href="#getstart" className="w-100 w-sm-auto d-flex justify-content-center" style={{ textDecoration: "none" }}>
                  <button
                    style={{
                      fontSize: "1.2rem",
                      fontFamily: "Prompt, sans-serif",
                      minWidth: "180px",
                      width: "100%",
                      maxWidth: "240px",
                      height: "50px",
                      borderRadius: "8px",
                      marginTop: "8px",
                    }}
                    className="shadow__btn"
                  >
                    <span className="btn-txt">{t('home.hero.aboutBtn')}</span>
                  </button>
                </a>
                <a href="#our-services" className="w-100 w-sm-auto d-flex justify-content-center" style={{ textDecoration: "none" }}>
                  <button
                    style={{
                      fontSize: "1.2rem",
                      fontFamily: "Prompt, sans-serif",
                      minWidth: "180px",
                      width: "100%",
                      maxWidth: "240px",
                      height: "50px",
                      background: "transparent",
                      border: "2px solid #f45555ff",
                      color: "#f56565ff",
                      padding: "10px 28px",
                      borderRadius: "8px",
                      fontWeight: "600",
                      letterSpacing: "2px",
                      textTransform: "uppercase",
                      transition: "all 0.3s ease",
                      marginTop: "8px",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = "#f76363ff";
                      e.target.style.color = "#ffffff";
                      e.target.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = "transparent";
                      e.target.style.color = "#f45d5dff";
                      e.target.style.transform = "translateY(0)";
                    }}
                  >
                    {t('home.hero.servicesBtn')}
                  </button>
                </a>
                
              </motion.div>

              {/* Key highlights */}
            </div>
          </motion.div>
        </div>
      </div>

      {/* เกี่ยวกับเรา */}
      <section
        id="getstart"
        className="position-relative overflow-hidden"
        style={{
          paddingTop: "120px",
          paddingBottom: "80px",
          background: `linear-gradient(135deg, #f8fafc 0%, #ffffff 50%, #f1f5f9 100%)`,
        }}
      >
        {/* Background image for 'เกี่ยวกับเรา' section */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            // backgroundImage: "url('https://images.vexels.com/content/143715/preview/colorful-abstract-background-with-rounded-shapes-620d05.png')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: 0.5,
            zIndex: 0,
            pointerEvents: "none",
          }}
        ></div>
        {/* Background decorative elements */}
        <div
          style={{
            position: "absolute",
            top: "10%",
            right: "-5%",
            width: "300px",
            height: "300px",
            background:
              "linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(147, 51, 234, 0.1))",
            borderRadius: "50%",
            filter: "blur(40px)",
            zIndex: 1,
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            bottom: "20%",
            left: "-5%",
            width: "250px",
            height: "250px",
            background:
              "linear-gradient(135deg, rgba(16, 185, 129, 0.1), rgba(59, 130, 246, 0.1))",
            borderRadius: "50%",
            filter: "blur(40px)",
            zIndex: 1,
          }}
        ></div>

        <div className="container">
          {/* Header Section */}
          <motion.div
            className="text-center mb-5"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
          >
            <motion.h2
              className="display-4 fw-bold mb-3"
              style={{
                fontFamily: "Prompt, sans-serif",
                background: "#322a57ff",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              {t('home.about.title')}
            </motion.h2>
            <motion.div
              initial={{ width: 0 }}
              whileInView={{ width: "120px" }}
              transition={{ duration: 1, delay: 0.5 }}
              viewport={{ once: true }}
              className="mx-auto mb-4"
              style={{
                height: "4px",
                background: "#ff5d5dff",
                borderRadius: "2px",
              }}
            />
            <p className="lead text-muted" style={{ fontFamily: "Prompt, sans-serif", maxWidth: "1000px", margin: "0 auto" }}>
              {t('home.about.subtitlePart1')}{t('home.about.years')}{t('home.about.subtitlePart2')}
            </p>
          </motion.div>

          {/* Main Content Row */}
          <motion.div
            className="row align-items-stretch mb-5"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
          >
            {/* Image Column */}
            <div className="col-lg-4 mb-4 mb-lg-0">
              <motion.div

                className="position-relative h-100"
              >
                <img
                  src={about}
                  alt="เกี่ยวกับบริษัท สำนักงานอรอนงค์ การบัญชีและสอบบัญชี"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    opacity: 0.2,
                    
                  }}
                />
                <div
                  className="position-absolute"
                  style={{
                    top: "-15px",
                    left: "-15px",
                    right: "15px",
                    bottom: "15px",
                    background: "linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(139, 92, 246, 0.1))",
                    borderRadius: "25px",
                    zIndex: -1,
                  }}
                />
              </motion.div>
            </div>
            
            {/* Content Column */}
            <div className="col-lg-8">
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, delay: 0.3 }}
                viewport={{ once: true }}
                className="h-100"
              >
                <div className="card border-0 shadow-lg h-100">
                  <div className="card-body p-5 d-flex flex-column justify-content-between">
                    <div>
                      <h3 className="card-title h2 mb-4 text-danger" style={{ fontFamily: "Prompt, sans-serif" }}>
                        {t('home.about.whoTitle')}
                      </h3>
                      <p className="card-text fs-5 mb-4" style={{ fontFamily: "Prompt, sans-serif", lineHeight: "1.8" }}>
                        <strong className="text-danger">{t('home.about.companyName')}</strong>{' '}
                        {t('home.about.paragraph1')}
                      </p>
                      <p className="card-text fs-6 mb-4" style={{ fontFamily: "Prompt, sans-serif", lineHeight: "1.7", color: "#6b7280" }}>
                        {t('home.about.paragraph2Pre')}
                        <strong>{t('home.about.subsidiaryName')}</strong>
                        {t('home.about.paragraph2Post')}
                      </p>
                    </div>

                    {/* Achievement Stats */}
                    <div className="mb-4">
                      <div className="row g-3" style={{ fontFamily: "Prompt, sans-serif" }}>
                        <div className="col-sm-6">
                          <div className="d-flex align-items-center p-3 bg-light rounded-3 h-100">
                            <div className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0" style={{ width: "55px", height: "55px" }}>
                              <span className="fw-bold fs-6">50+</span>
                            </div>
                            <div>
                              <div className="fw-bold text-danger">{t('home.about.yearsStatLabel')}</div>
                              <small className="text-muted">{t('home.about.yearsStatSubLabel')}</small>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="d-flex align-items-center p-3 bg-light rounded-3 h-100">
                            <div className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0" style={{ width: "55px", height: "55px" }}>
                              <span className="fw-bold fs-6">CPA</span>
                            </div>
                            <div>
                              <div className="fw-bold text-danger">{t('home.about.cpaStatLabel')}</div>
                              <small className="text-muted">{t('home.about.cpaStatSubLabel')}</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="mt-auto">
                      <a href="history" className="btn btn-danger btn-lg px-4 py-3" style={{ fontFamily: "Prompt, sans-serif", letterSpacing: "1px", fontWeight: "600" }}>
                        {t('home.about.historyBtn')} <i className="fas fa-arrow-right ms-2"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>
          </motion.div>

          
        </div>
      </section>
      {/* ใบรับรอง */}
      <div id="certificate" style={{ scrollMarginTop: "50px" }}>
        <Certificate />
      </div>

      {/* บริการของเรา */}
      <div id="our-services" style={{ scrollMarginTop: "50px" }}>
        <OurServicesSection />
      </div>

      {/* ความคิดเห็นจากลูกค้า
      <div
        className="container"
        style={{ paddingTop: "80px", paddingBottom: "80px" }}
      >
        <motion.h2
          className="text-center mb-5"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
          style={{
            fontSize: "3rem",
            fontWeight: "bold",
            fontFamily: "Prompt, sans-serif",
            color: "#335fd6",
          }}
        >
          ความคิดเห็นจากลูกค้า
        </motion.h2>
        <div className="row justify-content-center">
          {[
            {
              name: "คุณสมชาย พ.",
              company: "บริษัท สมาร์ทเทค จำกัด",
              comment:
                "บริการดีมาก ให้คำปรึกษาอย่างละเอียดและเป็นกันเอง ประทับใจมากครับ ขอแนะนำสำหรับใครที่มองหาทีมบัญชีมืออาชีพจริง ๆ ครับ!",
              avatar: "https://randomuser.me/api/portraits/men/26.jpg",
              rating: 5,
              date: "10 ก.ค. 2025",
            },
            {
              name: "คุณอรทัย ว.",
              company: "หจก. อรทัยการบัญชี",
              comment:
                "ทีมงานมืออาชีพ ตอบทุกข้อสงสัยและช่วยวางแผนภาษีได้ดีมากค่ะ ประทับใจในความใส่ใจและความรวดเร็วในการให้บริการมาก ๆ ค่ะ",
              avatar: "https://randomuser.me/api/portraits/women/8.jpg",
              rating: 5,
              date: "5 ก.ค. 2025",
            },
            {
              name: "คุณณัฐวุฒิ ก.",
              company: "บริษัท เอ็นเอ็นดีเวลลอปเมนท์ จำกัด",
              comment:
                "ประทับใจในความรวดเร็วและความใส่ใจของทีมงานครับ งานเอกสารถูกต้องครบถ้วนและให้คำแนะนำดีมากครับ",
              avatar: "https://randomuser.me/api/portraits/men/67.jpg",
              rating: 4,
              date: "28 มิ.ย. 2025",
            },
          ].map((item, i) => (
            <motion.div
              className="col-lg-4 col-md-6 mb-4"
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.2, duration: 0.8 }}
              viewport={{ once: true }}
            >
              <div
                className="p-4 shadow rounded-4 h-100 bg-white position-relative"
                style={{ minHeight: 260, borderTop: "6px solid #335fd6" }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: 18,
                    right: 24,
                    fontSize: 32,
                    color: "#e0e7ff",
                    opacity: 0.7,
                  }}
                >
                  <span>“</span>
                </div>
                <div className="d-flex align-items-center mb-2">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    width="56"
                    height="56"
                    style={{
                      borderRadius: "50%",
                      marginRight: 16,
                      border: "2px solid #335fd6",
                    }}
                  />
                  <div>
                    <span
                      style={{
                        fontWeight: 600,
                        fontFamily: "Prompt, sans-serif",
                        fontSize: "1.1rem",
                        color: "#335fd6",
                      }}
                    >
                      {item.name}
                    </span>
                    <div
                      style={{
                        fontSize: "0.95rem",
                        color: "#888",
                        fontFamily: "Prompt, sans-serif",
                      }}
                    >
                      {item.company}
                    </div>
                  </div>
                </div>
                <div
                  className="mb-2"
                  style={{ color: "#fbbf24", fontSize: "1.1rem" }}
                >
                  {Array.from({ length: 5 }).map((_, idx) => (
                    <span key={idx}>{idx < item.rating ? "★" : "☆"}</span>
                  ))}
                  <span
                    style={{
                      color: "#888",
                      fontSize: "0.95rem",
                      marginLeft: 8,
                    }}
                  >
                    {item.date}
                  </span>
                </div>
                <p
                  style={{
                    fontSize: "1.15rem",
                    fontFamily: "Prompt, sans-serif",
                    color: "#333",
                    minHeight: 80,
                  }}
                >
                  {item.comment}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div> */}

      {/* ติดต่อเรา */}
      


      <div id="contact"  style={{ scrollMarginTop: "50px" }}>
        <Contact />
      </div>
    </>
  );
}


      

export default HomePage;
